import React from "react";
import "../../style/customslider.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

function FeaturedCollection() {
  const navigate = useNavigate();
  var settings = {
    // dots: true,
    infinite: true,
    // centerPadding:"18px",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          // centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          // centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 820,
        settings: {
          centerMode: false,
          slidesToShow: 2.8,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1.05,
        },
      },
    ],
    // prevArrow: '<button class="sliderButton prev"></button>',
  };

  const allCollection = () => {
    navigate("/featured-collection");
  };

  return (
    <div>
      <section>
        <div className="pt120 pb-3">
          <div className="d-flex justify-content-between align-items-center pb-4">
            <h3>Featured Collection</h3>
            <div>
              <button className="allbutton" onClick={() => allCollection()}>
                See all
              </button>
            </div>
          </div>
          {/* <div className="featuredCollection pt-4 d-flex "> */}

          <Slider {...settings}>
            <div className="collection">
              <div className="featuredName">
                <div className="d-flex align-items-center gap-lg-3 gap-1">
                  <img
                    src="Screen Shot 2021-12-21 at 12.38 8.png"
                    alt="profile"
                    className="profile"
                  />
                  <div className="d-flex gap-2 align-items-center">
                    <h5>ApeYachtClub</h5>
                    <img src="signed 1.png" alt="tick" className="tick" />
                  </div>
                </div>
              </div>
              <img
                src="f1.png"
                alt="collection"
                className="bb w-100"
              />
            </div>
            <div className="collection">
              <div className="featuredName">
                <div className="d-flex align-items-center gap-lg-3 gap-1">
                  <img
                    src="Screen Shot 2021-12-21 at 12.37 9.png"
                    alt="profile"
                    className="profile"
                  />
                  <div className="d-flex gap-2 align-items-center">
                    <h5>Bubblegoose</h5>
                    <img src="signed 1.png" alt="tick" className="tick" />
                  </div>
                </div>
              </div>
              <img src="f2.png" alt="collection" className="bb w-100" />
            </div>
            <div className="collection">
              <div className="featuredName">
                <div className="d-flex align-items-center gap-lg-3 gap-1">
                  <img
                    src="Screen Shot 2021-12-21 at 12.37 8.png"
                    alt="profile"
                    className="profile"
                  />
                  <div className="d-flex gap-2 align-items-center">
                    <h5>DeGods</h5>
                    <img src="signed 1.png" alt="tick" className="tick" />
                  </div>
                </div>
              </div>
              <img src="f3.png" alt="collection" className="bb w-100" />
            </div>
            <div className="collection">
              <div className="featuredName">
                <div className="d-flex align-items-center gap-lg-3 gap-1">
                  <img
                    src="Screen Shot 2021-12-21 at 12.38 9.png"
                    alt="profile"
                    className="profile"
                  />
                  <div className="d-flex gap-2 align-items-center">
                    <h5>Midnight Panthers</h5>
                    <img src="signed 1.png" alt="tick" className="tick" />
                  </div>
                </div>
              </div>
              <img src="f5.png" alt="collection" className="bb w-100" />
            </div>
            <div className="collection">
              <div className="featuredName">
                <div className="d-flex align-items-center gap-lg-3 gap-1">
                  <img
                    src="Screen Shot 2021-12-21 at 12.37 9.png"
                    alt="profile"
                    className="profile"
                  />
                  <div className="d-flex gap-2 align-items-center">
                    <h5>Bubblegoose</h5>
                    <img src="signed 1.png" alt="tick" className="tick" />
                  </div>
                </div>
              </div>
              <img src="f1.png" alt="collection" className="bb w-100" />
            </div>
          </Slider>
        </div>
      </section>
    </div>
  );
}

export default FeaturedCollection;
